import { Add } from "@mui/icons-material";
import { Grid, IconButton, Tooltip, Typography } from "@mui/material";
import moment from "moment";
import React from "react";
import { PlanWeek, PlanWorkout } from "@readyfit-common/models";
import { useAppDispatch } from "src/store/hooks";
import {
  setSelectedDate,
  setSelectedDayNumber,
  setSelectedWeek,
  setSelectedWorkout,
  setWorkoutModalOpen,
} from "src/store/reducers/training/trainingApiSlice";
import useStyles from "./Header.style";

interface HeaderProps {
  workouts: PlanWorkout[];
  week: PlanWeek;
  isToday?: boolean;
  isTemplate?: boolean;
  isEditable?: boolean;
  index: number;
  date: string;
}

const Header = ({
  workouts,
  week,
  isToday,
  isTemplate,
  index,
  isEditable,
  date,
}: HeaderProps) => {
  const days = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
  const css = useStyles({ isToday: isToday || false })();
  const workoutOfTheDay = workouts?.[0];
  const dispatch = useAppDispatch();

  const handleOpenAddWorkoutModal = () => {
    dispatch(setWorkoutModalOpen(true));
    dispatch(setSelectedWeek(week));
    if (!isTemplate) {
      dispatch(setSelectedDate(date));
    }
    dispatch(setSelectedWorkout(null));
    dispatch(setSelectedDayNumber(index + 1));
  };

  return (
    <Grid container className={css.header}>
      <Grid container>
        <Grid container item xs={10} className={css.day}>
          <Typography
            variant="subtitle1"
            color={isToday ? "#fff" : "#000"}
            fontWeight={"bold"}
          >
            {days[workoutOfTheDay?.dayNumber - 1]?.toUpperCase()}
          </Typography>
          {!isTemplate && (
            <Typography
              variant="caption"
              color={isToday ? "#fff" : "#000"}
              fontWeight={"bold"}
            >
              {moment(workoutOfTheDay?.date).format("DD")}
            </Typography>
          )}
        </Grid>
        {isEditable && (
          <Grid item xs={2}>
            <Tooltip title="Add">
              <IconButton onClick={handleOpenAddWorkoutModal}>
                <Add style={{ color: isToday ? "#fff" : "#000" }} />
              </IconButton>
            </Tooltip>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default Header;
